import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _BootstrapGetter = Getter.of();
export const _BootstrapResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _BootstrapResponse2Bootstrap = _Response2ResponseData();
export const _Bootstrap2Data = Fold.compose(_BootstrapGetter, Res._Response());
export const _Bootstrap2Attributes = Fold.compose(_Bootstrap2Data, Lens.prop("attributes"));
export const _BootstrapAttributes2DisplayTerritoryPicker = Fold.compose(_Bootstrap2Attributes, Lens.prop("displayTerritoryPicker"));
export const _BootstrapAttributes2AuthDomainUrl = Fold.compose(_Bootstrap2Attributes, Lens.prop("authDomainUrl"));
export const _BootstrapAttributes2BaseApiUrl = Fold.compose(_Bootstrap2Attributes, Lens.prop("baseApiUrl"));
export const _BootstrapAttributes2Realm = Fold.compose(_Bootstrap2Attributes, Lens.prop("realm"));
export const _BootstrapAttributes2Environment = Fold.compose(_Bootstrap2Attributes, Lens.prop("environment"));
export const _BootstrapAttributes2MainTerritoryCode = Fold.compose(_Bootstrap2Attributes, Lens.prop("mainTerritoryCode"));

